const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时全网监控娱乐圈动态，重大黑料30分钟内上线，51吃瓜与17c黑料爆料实时同步，吃瓜不等待。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多重验证',
    desc: '每条爆料经多方交叉核实，标注可信度等级。已证实与待核实一目了然，让吃瓜群众理性吃瓜不盲从。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量瓜田',
    desc: '2000+累计爆料覆盖明星黑料、娱乐圈八卦、网红翻车、综艺争议，吃瓜群众想看的这里都有。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '随时吃瓜',
    desc: '完美适配手机平板电脑，添加到桌面秒变App，通勤摸鱼睡前随时刷新，不错过任何一个热门大瓜。',
  },
  {
    icon: 'ri-user-voice-line',
    title: '吃瓜社区',
    desc: '百万吃瓜群众聚集地，热门评论区神评频出。投稿爆料还有奖励，你的独家线索可能就是下一个爆款。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">为什么选择我们</h2>
          <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">5大优势</span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">黑料爆料吃瓜网用实力证明，这里是吃瓜群众的最佳选择</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70 hover:bg-primary-50/30 transition-colors cursor-default text-center lg:text-left"
            >
              <div className="w-12 h-12 rounded-lg bg-secondary-100 text-secondary-600 flex items-center justify-center mb-4 mx-auto lg:mx-0 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}